export default __webpack_public_path__ + "static/media/MilkTeaPouring2.a6243c32.gif";